<template>

    <main class="gmp-page gmp-page--no-newsletter">
        <GOODS_subpagehero />
        <GOODS_two_column_text />
        <GOODS_two_column_fullbleed />

    </main>

</template>


<script>
    import GOODS_subpagehero from "../../../components/content/market/benefit/GOODS_subpagehero";
    import GOODS_two_column_text from "../../../components/content/market/benefit/GOODS_two_column_text";
    import GOODS_two_column_fullbleed from "../../../components/content/market/benefit/GOODS_two_column_fullbleed";


    export default {
        name: 'GOODS_Benefit',
        components:{
            GOODS_subpagehero,
            GOODS_two_column_text,
            GOODS_two_column_fullbleed,

        }

    }


</script>

<style>



</style>